<template>
    <div id="loginOrRegister" aria-hidden="true"
         class="modal modal--rebrand fade over-all modal-with-custom-content modal-with-custom-content--dark-background"
         role="dialog" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-content-tabs">
                    <button @click.prevent="changeTab('guest')" :class="{'active': isGuestActive}">
                        {{ translate.home.guestGallery.guest }}
                    </button>
                    <button @click.prevent="changeTab('register')" :class="{'active': isRegisterActive}">
                        {{ translate.login.modalRegisterGallery.register }}
                    </button>
                    <button @click.prevent="changeTab('login')" :class="{'active': isLoginActive}">
                        {{ translate.login.login }}
                    </button>
                </div>

                <private-gallery-guest-modal-contents v-if="isGuestActive"
                                                      :galleryDetails="galleryDetails"
                                                      @signIn="changeTab('login')"
                                                      @onCodeInput="onGuestGalleryCodeInput"
                ></private-gallery-guest-modal-contents>

                <div class="modal-body" v-if="isRegisterActive">
                    <h5 class="heading mb-2" v-html="translate.home.registrationModal.registerForFree"></h5>
                    <p class="subheading mb-2">{{ translate.home.registrationModal.withFreeAccountYouGet }}</p>
                    <ul class="d-flex flex-column gap-2 mb-3">
                        <li v-for="(item, index) in translate.home.registrationModal.advantagesList" :key="index">
                            <icon-component :icon="checkmarkDouble()"/>
                            {{ item }}
                        </li>
                    </ul>
                    <punter-registration-component @successRedirect="onRegistrationSuccess"/>
                </div>
                <div class="modal-body" v-if="isLoginActive">
                    <h5 class="heading mb-2">{{ translate.login.login }}</h5>
                    <p class="subheading mb-3">{{ translate.login.signInToYourAccount }}</p>
                    <punter-login-component :galleryId="galleryId" @successRedirect="onLoginSuccess"/>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

import userMixin from "@/components/mixins/userMixin";
import PunterRegistrationComponent from "@/components/users/auth/PunterRegistrationComponent";
import PunterLoginComponent from "@/components/users/auth/PunterLoginComponent";
import privateGalleriesMixin from "@/components/mixins/gallery/privateGalleriesMixin";
import localStorageMixin from "@/components/mixins/localStorageMixin";
import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";
import ButtonWithLoadingComponent from "@/components/global/ButtonWithLoadingComponent";
import PrivateGalleryGuestModalContents from "@/components/users/modals/partials/PrivateGalleryGuestModalContents";
import IconComponent from "@/components/global/IconComponent.vue";
import {checkmarkDouble} from "@/core/constants/icons";

const data = () => {
    return {
        activeTab: 'guest',
        galleryId: null,
        galleryDetails: null,
    }
}

function initModal(details) {
    this.galleryDetails = details;
    this.galleryId = details.id;
    $('#loginOrRegister').modal('show');
}

function changeTab(tab) {
    this.activeTab = tab;
}

function onRegistrationSuccess() {
    this.setProfileInGalleryDataToLocalStorage(this.galleryDetails);
    $('#loginOrRegister').modal('hide');
    this.setPaymentRedirectLink(window.location.href);
    window.location.href = this.regionRelativeUrl('/client/onboarding/');
}

function onLoginSuccess() {
    this.setProfileInGalleryDataToLocalStorage(this.galleryDetails);
    window.location.reload();
}

function onGuestGalleryCodeInput() {
    $('#loginOrRegister').modal('hide');
    this.$emit('refreshComponent')
}

export default {
    components: {
        IconComponent,
        PrivateGalleryGuestModalContents, ButtonWithLoadingComponent, PunterLoginComponent, PunterRegistrationComponent,
    },
    data,
    methods: {
        checkmarkDouble,
        initModal,
        changeTab,
        onRegistrationSuccess,
        onLoginSuccess,
        onGuestGalleryCodeInput,
    },
    mixins: [userMixin, privateGalleriesMixin, localStorageMixin, regionsUrlMixin],
    computed: {
        ...mapState(['translate']),
        isRegisterActive() {
            return this.activeTab === 'register';
        },
        isLoginActive() {
            return this.activeTab === 'login';
        },
        isGuestActive() {
            return this.activeTab === 'guest';
        },
    },
    beforeDestroy() {
        window.clearModalFade();
    },
};
</script>
